/* eslint-disable */
export default {
  loading: 'Cargando…',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
